import { ImportPoCsvBatchResult } from "@redotech/redo-inventory-common/po-csv-upload";
import * as z from "zod";

export const uploadPurchaseOrdersCsv = {
  name: "uploadPurchaseOrdersCsv" as const,
  input: z.object({}),
  output: ImportPoCsvBatchResult,
};
